(function () {



/* ===================================
    Home 01
======================================*/

jQuery("#rev_slider_35_1").show().revolution({
    sliderType:"standard",
    // jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
            mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"new-1",
            hide_onleave:false,
            direction:"vertical",
            h_align:"right",
            v_align:"bottom",
            h_offset:60,
            v_offset:80,
            space:5,
            tmp:'<span class="tp-bullet-title">{{title}}</span>'
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[1080,576,438,720],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }


});



/* ===================================
Home 02
======================================*/
jQuery("#rev_slider_36_1").show().revolution({
    sliderType:"carousel",
	// jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
            mouseScrollReverse:"default",
        onHoverStop:"off",
        arrows: {
            style:"gyges",
            enable:true,
            hide_onmobile:false,
            hide_onleave:false,
            tmp:'',
            left: {
                container:"layergrid",
                h_align:"left",
                v_align:"center",
                h_offset:20,
                v_offset:0
            },
            right: {
                container:"layergrid",
                h_align:"right",
                v_align:"center",
                h_offset:20,
                v_offset:0
            }
        }
        ,
        bullets: {
            enable:true,
            hide_onmobile:false,
            hide_over:1024,
            style:"ares",
            hide_onleave:false,
            direction:"horizontal",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:40,
            space:5,
            tmp:'<span class="tp-bullet-title">{{title}}</span>'
        }
    },
    carousel: {
        horizontal_align: "center",
        vertical_align: "center",
        fadeout: "on",
        vary_fade: "off",
        maxVisibleItems: 3,
        infinity: "on",
        space: 30,
        stretch: "off",
            showLayersAllTime: "on",
            easing: "Power3.easeInOut",
            speed: "800"
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[970,970,778,480],
    gridheight:[755,755,606,720],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});


/* ===================================
Home 03
======================================*/
jQuery("#rev_slider_37_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"new-1",
            hide_onleave:false,
            direction:"vertical",
                container:"layergrid",
            h_align:"left",
            v_align:"bottom",
            h_offset:180,
            v_offset:90,
            space:5,
            tmp:'<span class="tp-bullet-title">{{title}}</span>'
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[1080,576,438,620],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});



/* ===================================
Home 03
======================================*/
jQuery("#rev_slider_38_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"hephaistos",
            hide_onleave:false,
            direction:"horizontal",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:0,
            space:20,
            tmp:''
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[765,500,450,680],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});


/* ===================================
Home 05
======================================*/
jQuery("#rev_slider_39_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"hesperiden",
            hide_onleave:false,
            direction:"horizontal",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:40,
            space:10,
            tmp:''
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[900,480,365,620],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});



/* ===================================
Home 08
======================================*/
jQuery("#rev_slider_40_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        arrows: {
            style:"gyges",
            enable:true,
            hide_onmobile:true,
            hide_under:1024,
            hide_onleave:false,
            tmp:'',
            left: {
                container:"layergrid",
                h_align:"left",
                v_align:"bottom",
                h_offset:370,
                v_offset:52
            },
            right: {
                container:"layergrid",
                h_align:"right",
                v_align:"bottom",
                h_offset:370,
                v_offset:52
            }
        }
        ,
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"new-2",
            hide_onleave:false,
            direction:"horizontal",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:80,
            space:5,
            tmp:'{{title}}'
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[1028,548,417,720],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});


/* ===================================
Home 10
======================================*/
jQuery("#rev_slider_41_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"new-1",
            hide_onleave:false,
            direction:"vertical",
            h_align:"right",
            v_align:"bottom",
            h_offset:30,
            v_offset:40,
            space:5,
            tmp:'<span class="tp-bullet-title">{{title}}</span>'
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1400,1024,778,480],
    gridheight:[720,527,400,620],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});



/* ===================================
Home 11
======================================*/
jQuery("#rev_slider_43_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"new-11",
            hide_onleave:false,
            direction:"vertical",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:0,
            space:5,
            tmp:'<span class="tp-bullet-title">{{title}}</span>'
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1760,1024,778,480],
    gridheight:[890,520,400,620],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});

/* ===================================
Home 12
======================================*/
jQuery("#rev_slider_42_1").show().revolution({
    sliderType:"standard",
//jsFileLocation:"//localhost/revslider-standalone/revslider/public/assets/js/",
    sliderLayout:"auto",
    dottedOverlay:"none",
    delay:9000,
    navigation: {
        keyboardNavigation:"off",
        keyboard_direction: "horizontal",
        mouseScrollNavigation:"off",
         mouseScrollReverse:"default",
        onHoverStop:"off",
        bullets: {
            enable:true,
            hide_onmobile:false,
            style:"hesperiden",
            hide_onleave:false,
            direction:"horizontal",
            h_align:"center",
            v_align:"bottom",
            h_offset:0,
            v_offset:60,
            space:10,
            tmp:''
        }
    },
    responsiveLevels:[1240,1024,778,480],
    visibilityLevels:[1240,1024,778,480],
    gridwidth:[1920,1024,778,480],
    gridheight:[994,530,410,620],
    lazyType:"none",
    shadow:0,
    spinner:"spinner0",
    stopLoop:"off",
    stopAfterLoops:-1,
    stopAtSlide:-1,
    shuffle:"off",
    autoHeight:"off",
    disableProgressBar:"on",
    hideThumbsOnMobile:"off",
    hideSliderAtLimit:0,
    hideCaptionAtLimit:0,
    hideAllCaptionAtLilmit:0,
    debugMode:false,
    fallbacks: {
        simplifyAll:"off",
        nextSlideOnWindowFocus:"off",
        disableFocusListener:false,
    }
});











})(jQuery);